module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/74bde1e0cf8208279316d392a8e04f2c.png";